(ns app.front.view.admin.migration.uri-path-ids
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/generate-uri-path-ids
    :title     "Generate URI path IDs for domain groups"
    :help-text (str "Generates :group/uri-path-id for all domain groups that don't have one. "
                    "Uses the left-most subdomain of group domain, group name or group-id, normalized to a URL-safe format, "
                    "falling back as needed if the value is blank, in the list of banned brandings or not unique.")}
   match])

(def route
  {:name        :view/admin.migration.uri-path-ids
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/generate-uri-path-ids]))}]})
